export const twitterMostViewedVideosCopy = {
  title: 'Most Viewed Videos',
  tooltip: 'Your Posts that received the highest number of views during the selected date range',
  emptyMessage: 'No X videos found during this reporting period',
};

export const tooltips = {
  noBrandPermission: "Looks like this feature isn't included in your plan!",
  noUserPermission: "Looks like you don't have permission to use this feature!",
  connectCallToAction:
    "Dash Social brings you all of the insights you love, including X! Ask your Dash Social administrator to provide you access. Or if this feature isn't in your package, contact your Customer Success Representative to try it out!",

  engagementRate:
    'The percentage of your audience that engaged with your organic Posts. Engagement Rate = Total Engagements / Impressions',
  engagements:
    'The total number of times your organic Posts have been interacted with. Includes reposts, replies, likes, and clicks.',
  impressions: 'The number of times your organic Posts were viewed.',
  likes: 'The number of times your organic Posts have been liked.',
  linkClicks: 'The number of times links have been clicked on your organic Posts.',
  netNewFollowers: 'The net number of new followers you gained during the selected time period.',
  replies: 'The number of times your organic Posts have been replied to.',
  totalRetweets: 'The number of times your organic Posts have been reposted or quote posted.',
  userProfileClicks: 'The number of times your profile has been clicked from your organic Posts.',
  videoViews: 'The number of times your organic videos have been viewed.',
};

export const twitterMediaCardDefaults = {
  labels: {
    engagements: 'Total Engagements',
    urlClicks: 'Link Clicks',
    follows: 'User Follows',
    userProfileClicks: 'Profile Clicks',
  },
  metrics: ['engagementRate', 'engagements', 'impressions', 'likes'],
};
